import React from 'react';
import useIntersectionObserver from '../../../hooks/useIntersectionObserver';
import backgroundImage from '../../../assets/G9TfL0_2_.png';
import signatureImage from '../../../assets/signature2.png';
import dishImage from '../../../assets/_I5A7596-fotor-202503241074.png';
import LucaFantin from "../../../assets/Luca_Fantin_1_S.jpg"
import pumpkin from "../../../assets/_I5A0126.jpg"
import TestingFood from "../../../assets/_I5A7535_1.jpg"

const AboutUsSection = ({t}) => {
    const [ref, inView] = useIntersectionObserver();

    return (
        <section id="about-us" className="py-20" ref={ref}>
            <div className="container mx-auto px-4">
                <div className="flex flex-wrap items-center">
                    <div className="w-full mb-10 md:mb-0">
                        <div className="flex flex-col md:flex-row">
                            <div className="w-full md:w-1/2 pr-0 md:pr-4">
                                <h5 className="text-[#C7702A] text-[15px] font-normal mb-0 uppercase tracking-normal leading-[28.8px] font-['Jost',sans-serif]">
                                    {t?.title}
                                </h5>
                                <h2 className="text-[45px] __libre-caslon-display leading-[54px] tracking-[-0.675px] text-[#1F0707] mt-2 mb-4">
                                    {t?.subTitle}
                                </h2>
                            </div>
                            <div className="w-full md:w-1/2 pl-0 md:pl-4">
                                <p className="text-[rgba(31,7,7,0.62)] mb-6 font-['Jost',sans-serif] text-[18px] font-normal leading-[28.8px] transition-all duration-300 ease-in-out italic">{t?.sortDescription}</p>
                                {/* <p className="text-[rgba(31,7,7,0.62)] font-['Jost',sans-serif] text-[18px] font-normal leading-[28.8px] transition-all duration-300 ease-in-out">Luca goes beyond the kitchen, personally meeting farmers and suppliers across Japan. He even hunts deer and forages for mushrooms, believing that knowing the origin of his ingredients is essential to his craft.</p> */}
                            </div>
                        </div>
                    </div>
                    <div className="w-full">
                        <div className="grid grid-cols-4 gap-4">
                            {/* First column */}
                            <div className="col-span-1 pt-[30%] relative">
                                <img 
                                    src={pumpkin}
                                    alt="Chef garnishing meat plate"
                                    width={1333}
                                    height={2000}
                                    className="w-full h-auto object-cover aspect-[1333/2000]"
                                />
                                {/* Signature image positioned between first and second column */}
                                <div className="absolute -right-1/2 bottom-0 z-10 transform -rotate-9">
                                    <img 
                                        src={signatureImage}
                                        alt="Signature"
                                        width={515}
                                        height={224}
                                        className="w-full h-auto"
                                        style={{transform: 'translateX(10%) translateY(-30%) rotate(-5deg)'}}
                                    />
                                </div>
                            </div>

                            {/* Middle two columns */}
                            <div className="col-span-2 relative flex justify-center">
                                <div className="absolute inset-0 flex justify-center items-center">
                                    <img 
                                        src={backgroundImage}
                                        alt="Decorative element"
                                        width={533}
                                        height={622}
                                        className="w-full h-auto opacity-35"
                                        style={{ transform: 'translateX(42%) translateY(-36%) rotate(40deg) scale(0.2)' }}
                                    />
                                </div>
                                <img 
                                    src={LucaFantin}
                                    alt="Male chef posing with hands crossed"
                                    width={933}
                                    height={1400}
                                    className="w-4/5 h-auto relative"
                                />
                            </div>

                            {/* Last column */}
                            <div className="col-span-1 relative pt-[40%]">
                                <div className="absolute w-full">
                                    <img 
                                        src={TestingFood}
                                        alt="Senior man serving fish for family at Christmas dinner"
                                        width={1198}
                                        height={1800}
                                        className="w-full h-auto object-cover"
                                    />
                                </div>
                                <div className="absolute top-[60%]">
                                    <div style={{transform: 'translateX(-8%) translateY(17%) rotate(5deg)'}}>
                                        <img 
                                            src={dishImage}
                                            alt="Appetizing bruschetta"
                                            width={1000}
                                            height={1000}
                                            className={`w-[55%] h-auto transition-opacity duration-1000 ${inView ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUsSection;
